module.exports = __webpack_public_path__ + "62dbc540d68ec422407958f7911c6874.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/twitter-logo.png
// module id = 380
// module chunks = 1